import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { PAGE_FLOW } from '../../../constants/proposalTypes'

// 取得批次提案的狀態
const usePageFlow = (phase, pageFlow) => {
  // 修改頁
  const isEditPage = (
    phase === PROPOSAL_PHASE_TYPE.COMPOSE &&
    pageFlow === PAGE_FLOW.EDIT
  )
  // 確認頁
  const isConfirmPage = (
    phase === PROPOSAL_PHASE_TYPE.COMPOSE &&
    pageFlow === PAGE_FLOW.CONFIRM
  )
  // 完成頁
  const isSuccessPage = (
    phase === PROPOSAL_PHASE_TYPE.COMPOSE &&
    pageFlow === PAGE_FLOW.SUCCESS
  )
  // 檢視頁
  const isOverviewPage = (
    phase === PROPOSAL_PHASE_TYPE.OVERVIEW
  )
  const readOnly = !isEditPage

  return {
    isEditPage,
    isConfirmPage,
    isSuccessPage,
    isOverviewPage,
    readOnly
  }
}

export default usePageFlow
